import React from "react";
import classnames from "classnames";

import { Button } from "../Common";

import "./index.scss";

interface InfoModalProps {
  heading: string;
  content: string;
  onClose: () => void;
  cancelBtnText?: string;
}

const InfoModal = (props: InfoModalProps) => {
  const { cancelBtnText, heading, content, onClose } = props;

  return (
    <div className={classnames("modal-content-wrapper", { "collapsed-margin": !content })}>
      <div className="modal-heading">{heading}</div>
      <div className="modal-content">{content}</div>
      <div className="modal-actions">
        <Button appearance="subtle" className="subtle auto-width" onClick={onClose}>
          {cancelBtnText}
        </Button>
      </div>
    </div>
  );
};
export default InfoModal;
